import React from 'react'

export const montanaSetupVars = {
  siteId: 'montana',
  pathPrefix: '/mt',
  menuHeader: "Discover Montana's Solution for:",
  appUrl: 'https://mt.headed2.com',
  logoImg: '/images/assets/montana/horizontal/dark.svg',
  headerTitle: `The Montana CareerExplorer is a system designed for Montana`
}
